import React from "react";
import { ArrowUpRight } from "lucide-react";

interface ExternalLinkProps {
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  hideArrow?: boolean;
}

const ExternalLink: React.FC<ExternalLinkProps> = ({ href, onClick, children, hideArrow = false }) => {
  const inner = (
    <>
      {children}
      {!hideArrow && (
        <ArrowUpRight size={12} strokeWidth={2} className="external-link-icon" />
      )}
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="external-link inline cursor-pointer border-x-0 border-t-0 bg-transparent p-0 pb-px align-baseline font-inherit leading-[1.1]"
      >
        {inner}
      </button>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="external-link"
    >
      {inner}
    </a>
  );
};

export default ExternalLink;
